import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { H as l } from "./chunks/index-UjijAVoZ.js";
import s from "./Jumbotron.js";
const i = ({ children: t, code: r, heading: o }) => /* @__PURE__ */ a(s, { className: "flex flex-col flex-grow gap-6 items-center justify-center px-5 py-10 overflow-hidden relative text-center tablet:py-12", children: [
  /* @__PURE__ */ e("span", { className: "absolute-center font-bold opacity-10 text-[25vw] z-[-1]", children: r }),
  /* @__PURE__ */ e(l, { className: "max-w-prose text-blue-500", level: "3", tagName: "h1", children: o }),
  t
] });
export {
  i as default
};
